import * as React from 'react';
import { Image, Pressable, ScrollView, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { useDispatch } from 'react-redux';
import { List, MD3Colors } from 'react-native-paper';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 10,
    paddingLeft: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
});

export function More({ navigation }) {

  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, getShowDebug, setDebug } = React.useContext(AppContext);

  const renderItemAccessory = (props, item) => (
    <Pressable onPress={() => navigation.navigate(item.route)}>
      <Image source={require('../../assets/chevron-right-grey.png')} style={AppConstants.STYLES.image25x25} />
    </Pressable>
  );

  const renderItemIcon = (props, item) => (
    <Pressable onPress={() => navigation.navigate(item.route)}>
      <Image source={item.icon} style={AppConstants.STYLES.image25x25} />
    </Pressable>
  );

  const onLongPress = (item) => {
    if (item.route == AppConstants.SCREENS.MORE_ABOUT) {
      setDebug(true);
      showTemporarySnack("Diagnostics enabled");
    }
  };
  
  const pressItem = (item) => {
    if (item.route) {
      navigation.navigate(item.route);
    } else {
      AppUtilities.openLink(item.link);
    }
  };

  const renderItem = (item) => (
    <List.Item
      key={item.title}
      title={item.title}
      description={item.description}
      left={props => renderItemIcon(props, item)}
      right={props => renderItemAccessory(props, item)}
      onPress={() => pressItem(item)}
      onLongPress={() => onLongPress(item)}
    />
  );

  const rows = [
    { title: "Filter", route: AppConstants.SCREENS.FILTER, description: "Change the level of certifications shown", icon: require('../../assets/filter-outline-darkgrey.png') },
    { title: "About", route: AppConstants.SCREENS.MORE_ABOUT, description: "About Find Humane", icon: require('../../assets/information-outline-grey.png') },
    { title: "FAQ", route: AppConstants.SCREENS.FAQ, description: "Frequently asked questions", icon: require('../../assets/chat-question-outline-grey.png') },
    { title: "Subscribe", route: AppConstants.SCREENS.MORE_SUBSCRIBE, description: "Get emails when products are added in your zip code", icon: require('../../assets/email-circle-outline-grey.png') },
    { title: "Learn more", route: AppConstants.SCREENS.LEARN, description: "Information about humane certifications", icon: require('../../assets/lightbulb-on-outline-grey.png') },
    { title: "Suggest Location", route: AppConstants.SCREENS.MORE_SUGGEST_LOCATION, description: "Suggest a location with humane animal products", icon: require('../../assets/plus-circle-outline-grey.png') },
    { title: "Contact Us", route: AppConstants.SCREENS.MORE_CONTACT, description: "Send us a comment, question, or suggestion", icon: require('../../assets/email-outline-grey.png') },
    //{ title: "List Near", route: AppConstants.SCREENS.MORE_LIST_LOCATIONS_NEAR, description: "List locations and products", icon: require('../../assets/list-ol-grey.png') },
    { title: "Blog", link: AppConstants.SUBSTACK_LINK, description: "Latest news and join our email newsletter", icon: require('../../assets/newspaper-variant-outline-grey.png') },
    { title: "Credits", route: AppConstants.SCREENS.CREDITS, description: "", icon: require('../../assets/information-outline-grey.png') },
    { title: "Privacy policy", route: AppConstants.SCREENS.MORE_PRIVACY, description: "", icon: require('../../assets/eye-off-outline-grey.png') },
    { title: "Other policies", route: AppConstants.SCREENS.MORE_POLICIES, description: "Producer-under-investigation policy, code of ethics, and ethical marketing policy", icon: require('../../assets/book-grey.png') },
    { title: "Terms of use", route: AppConstants.SCREENS.MORE_TERMS, description: "", icon: require('../../assets/gavel-grey.png') },
  ];

  if (AppConstants.IS_DEVELOPMENT) {
    rows.push({ title: "Test", route: AppConstants.SCREENS.MORE_TEST, description: "Test component", icon: require('../../assets/tools-grey.png') });
  }

  if (getShowDebug()) {
    rows.push({ title: "All products", route: AppConstants.SCREENS.ALL_PRODUCTS, description: "List all certified products", icon: require('../../assets/format-list-bulleted-type-25-grey.png') });
    rows.push({ title: "All producers", route: AppConstants.SCREENS.ALL_PRODUCERS, description: "List all certified producers", icon: require('../../assets/account-cowboy-hat-25-grey.png') });
    rows.push({ title: "Diagnostics", route: AppConstants.SCREENS.MORE_DEBUG, description: "View diagnostics to investigate problems with the app", icon: require('../../assets/tools-grey.png') });
  }

  return (
    <ScrollView style={styles.wrapper}>
      <List.Section>
        {rows.map((row) => renderItem(row))}
      </List.Section>
    </ScrollView>
  );
}
